export default "__VITE_ASSET__BTZGnF3H__"